import Layout from '@/layout'

const villageRouter = {
  path: '/addressBook',
  component: Layout,
  children: [
    {
      path: '/deptList',
      name: 'deptList',
      meta: {
        title: '部门管理',
      },
      component: () => import('@/views/addressBook/deptList.vue'),
    },
    {
      path: '/userList',
      name: 'userList',
      meta: {
        title: '人员管理',
      },
      component: () => import('@/views/addressBook/userList.vue'),
    },
  ],
}

export default villageRouter
